import { useQuery, useQueryClient } from '@tanstack/react-query'

import { extractData, useBuildRequest, useGenericErrorHandler, useRequestMutation } from './base'

export const SUSPECT_SCORE_QUERY_KEY = 'suspectScore'

export function useSuspectScores(subscriptionId?: string) {
  const buildRequest = useBuildRequest()
  const { withErrorHandling } = useGenericErrorHandler()

  return useQuery({
    queryKey: [SUSPECT_SCORE_QUERY_KEY, subscriptionId] as const,
    queryFn: ({ queryKey: [_, subId] }) =>
      extractData(withErrorHandling(buildRequest('suspectScores', { params: { subscriptionId: subId! } }))),
    enabled: !!subscriptionId,
  })
}

export function useSuspectScoresUpdateMutation() {
  const queryClient = useQueryClient()

  return useRequestMutation('suspectScoresUpdate', {
    onSuccess: (data, { params: { subscriptionId } = {} }) => {
      queryClient.setQueryData([SUSPECT_SCORE_QUERY_KEY, subscriptionId], () => data)
    },
  })
}
